import React, { useEffect, useState } from 'react';
import { preloadImage, isImageLoaded } from '../../../utils/imageCache';

const Logo = React.memo(
  ({ src, alt = 'Logo', className = '', loading = 'eager', ...rest }) => {
    const [ready, setReady] = useState(() => isImageLoaded(src));

    useEffect(() => {
      if (!src) return;
      if (isImageLoaded(src)) {
        setReady(true);
        return;
      }

      preloadImage(src).then(() => setReady(true));
    }, [src]);

    const classes = [className, !ready ? 'logo--loading' : '']
      .filter(Boolean)
      .join(' ');

    return (
      <img
        src={src}
        alt={alt}
        className={classes}
        loading={loading}
        decoding="async"
        {...rest}
      />
    );
  }
);

export default Logo;
